import React from 'react';
import { FadeIn } from './FadeIn';
import { Heart, ShoppingBag, Sparkles } from 'lucide-react';
export const Vision = () => {
  return <section className="py-24 bg-cream relative overflow-hidden" data-id="element-185">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent-rose/10 rounded-full blur-3xl pointer-events-none" data-id="element-186" />

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-187">
        <FadeIn className="text-center mb-16" data-id="element-188">
          <h2 className="text-4xl md:text-5xl mb-6 leading-tight" data-id="element-189">
            Imaginate recibir pedidos desde tu celular{' '}
            <br className="hidden md:block" data-id="element-190" />
            <span className="italic text-accent-rose-deep" data-id="element-191">
              mientras construís algo propio.
            </span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-192">
          <FadeIn delay={0.1} className="glass-panel p-8 rounded-3xl text-center relative group hover:-translate-y-2 transition-transform duration-300" data-id="element-193">
            <div className="w-16 h-16 mx-auto bg-nude rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-194">
              <Heart className="w-8 h-8 text-accent-rose-deep" data-id="element-195" />
            </div>
            <h3 className="text-xl mb-3 font-bold" data-id="element-196">Lifestyle Femenino</h3>
            <p className="text-text-brown/80" data-id="element-197">
              Manejá tus propios horarios, trabajá en un ambiente cozy y creá
              productos que ames.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} className="glass-panel p-8 rounded-3xl text-center relative group hover:-translate-y-2 transition-transform duration-300" data-id="element-198">
            <div className="w-16 h-16 mx-auto bg-nude rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-199">
              <ShoppingBag className="w-8 h-8 text-accent-rose-deep" data-id="element-200" />
            </div>
            <h3 className="text-xl mb-3 font-bold" data-id="element-201">Ventas Constantes</h3>
            <p className="text-text-brown/80" data-id="element-202">
              Convertí tu Instagram en una vitrina aesthetic que atraiga
              clientes ideales todos los días.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="glass-panel p-8 rounded-3xl text-center relative group hover:-translate-y-2 transition-transform duration-300" data-id="element-203">
            <div className="w-16 h-16 mx-auto bg-nude rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-204">
              <Sparkles className="w-8 h-8 text-accent-rose-deep" data-id="element-205" />
            </div>
            <h3 className="text-xl mb-3 font-bold" data-id="element-206">Marca Premium</h3>
            <p className="text-text-brown/80" data-id="element-207">
              Aprendé a crear un packaging y una experiencia que justifique
              cobrar precios más altos.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
};